// « Match présenté par » (D-033) : tout le monde voit le partenaire du match ; le
// bureau le choisit parmi les partenaires visibles du club.
import { clubPartners, setMatchPresentedBy, trackPartners, type PartnerCard } from '../lib/api';
import { type Ctx } from './context';
import { $, html, mount, toast } from './dom';
import { partnerMark } from './partners';

export async function renderPresentedBy(el: HTMLElement, ctx: Ctx, clubId: string, eventId: string,
  current: string | null, isHome: boolean | null): Promise<void> {
  const admin = ctx.adminOf.some(c => c.id === clubId);
  if (!admin && !current) { mount(el, html``); return; }
  const list = await clubPartners(clubId).catch(() => [] as PartnerCard[]);
  const p = list.find(x => x.id === current) ?? null;
  mount(el, html`
    <section class="block pt-presented">
      ${p ? html`
        <div class="pt-presented-line">
          ${partnerMark(p)}
          <span><span class="eyebrow">Match présenté par</span><strong>${p.name}</strong>${p.member_offer ? html`<span class="muted small">Offre membres : ${p.member_offer}</span>` : ''}</span>
        </div>` : ''}
      ${admin ? html`
        <label class="field"><span>${p ? 'Changer de partenaire' : 'Match présenté par (bureau)'}</span>
          <select id="pt-pick">
            <option value="">Aucun partenaire</option>
            ${list.map(x => html`<option value="${x.id}" ${x.id === current ? 'selected' : ''}>${x.name}${x.level ? ` · ${x.level}` : ''}</option>`)}
          </select></label>
        ${list.length ? html`<p class="hint">${isHome ? 'Affiché sur la page publique du club et dans l’app.' : 'Match à l’extérieur : affiché dans l’app.'} Compté dans la visibilité du partenaire.</p>`
          : html`<p class="hint">Ajoute d'abord des partenaires (écran Club › Partenaires).</p>`}` : ''}
    </section>`);
  if (p) trackPartners([p.id], 'match');
  $<HTMLSelectElement>(el, '#pt-pick')?.addEventListener('change', async (e) => {
    const v = (e.target as HTMLSelectElement).value || null;
    try {
      await setMatchPresentedBy(eventId, v);
      toast(v ? 'Partenaire du match enregistré' : 'Plus de partenaire pour ce match');
      await renderPresentedBy(el, ctx, clubId, eventId, v, isHome);
    } catch { toast('Enregistrement impossible.', 'ko'); }
  });
}
